export const GET_CONFIG_SUCCESS = 'GET_CONFIG_SUCCESS';

export const GET_VERSION_BACK_END_SUCCESS = 'GET_VERSION_BACK_END_SUCCESS';
export const GET_VERSION_BACK_END_FAIL = 'GET_VERSION_BACK_END_FAIL';
